import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Form,Input,Radio,Button,message,Icon,Checkbox } from 'antd';
import LoadingCover from 'components/LoadingCover';
import abortAjaxHoc from 'components/abortAjaxHoc';
import {mixObj} from 'utils/tool';
import style from './SDKLivenessForm.module.less';
import classnames from 'classnames';
import ItemAction from './ItemAction';
import ItemLiveInterfaceTips,{FormMap} from './ItemLiveInterfaceTips';
import {getLabel} from 'components/TipsView/tools';
import SubForm from 'components/SubForm';

const FormItem = Form.Item;
const defaultLivenessType = 'flash';
const Actions = [
    {value:4,label:'Nod'},
    {value:3,label:'Shake Head'},
    {value:2,label:'Open Mouth'},
    {value:1,label:'Blink'}
];
const ActionsMap = [
    {initValue:'please nod',key:'nod_guid_text',label:'Nod Action Copy'},
    {initValue:'please shake head',key:'shake_guid_text',label:'Shake Head Action Copy'},
    {initValue:'please open mouth',key:'mouth_guid_text',label:'Open Mouth Action Copy'},
    {initValue:'please blink',key:'blink_guid_text',label:'Blink Action Copy'}
];
const LabelMap = {
    'liveness_type':{
        label:'Choose liveness mode',
    },
    'flash_light':{
        label:'Whether to enable flash lighting',
        notice:{
            dec:'It will be silent liveness after the lighting is turned off, the detection rate drops slightly and the pass rate increases.',
        }
    },
    'device_risk':{
        label:'Whether to enable device risk detection',
        notice:{
            dec:'Turning on device risk detection can effectively defend against hacker attacks.'
        }
    },
    'get_liveness_video':{
        label:'Live capture video or picture whether to save',
    },
    'storage_video_mode':{
        label:'Storage video mode selection',
        dec:'Longer videos mean bigger file sizes, which can cause upload failures or crashes on low-end devices. Unless necessary, it\'s best to only keep the video of the Liveness stage.'
    },
    'liveness_action_count':{
        label:'Number of actions',
        notice:{
            dec:'The more  movements, the more comprehensive the defense capability and the higher the detection rate.'
        }
    },
    'liveness_timeout':{
        labelMap:{
            active:'Action collection timeout',
            active_flash:'Action collection timeout'
        },
        notice:{
            dec:'If the operation is not completed within the specified time, the living body collection will fail.',
        }
    },
    'flash_liveness_timeout':{
        labelMap:{
            flash:'Flash collection timeout',
            distance_flash:'Flash collection timeout',
            active_flash:'Total collection timeout'
        },
        notice:{
            dec:'If the operation is not completed within the specified time, the living body collection will fail.',
        }
    },
    'maximum_brightness':{
        label:'Whether to turn on the maximum brightness',
        notice:{
            dec:'After it is turned on, the brightness of the mobile phone screen will be automatically adjusted to the brightest to ensure the collection effect.'
        }
    },
    //此字段为本地字段，后端不需要此字段
    'interface_prompt_local':{
        label:'Whether to open the interface prompt',
        notice:{
            dec:'After opening, the interface will display prompt content'
        }
    },
    //此字段为本地字段，后端不需要此字段
    'liveness_active_type':{
        label:'Action type(SDK versions before V5.8.8 use configuration and only support one specified action type)',
        notice:{
            dec:'You can dynamically select the desired action type.'
        }
    },
    'distance_liveness_timeout':{
        label:'varifocal collection timeout',
        notice:{
            dec:'If the operation is not completed within the specified time, the living body collection will fail.'
        }
    },
    'active_liveness_timeout':{
        label:'Total timeout for liveness collection in speed scene',
        notice:{
            dec:'If the operation is not completed within the specified time, the living body collection will fail.',
        }
    },
    'speed_action_mode':{
        label:'Whether to enable the speed scene',
        notice:{
            dec:'Turn on the speed scene: For SDK V5.8.1 and later versions, active liveness will not perform actions; for SDK versions prior to V5.8.1, active liveness will perform actions normally according to the selected number of actions.',
        },
        tips:'Only supports SDK V5.8.1 and later versions'
    },
    'face_risk':{
        label:'Whether to enable face risk detection',
        notice:{
            dec:'When turned on, the face risk info is returned.'
        }
    },
    //新增全部活体文案
    'liveness_multi_active_guide_text':{
        label:'Action stage guide copy'
    },
    'active_flash_action_count':{
        label:'Number of Actions(SDK V5.8.8 and later versions use configuration and support multiple action types)'
    },
    'liveness_active_type_queue':{
        label:'Action Type',
        notice:{
            dec:'When >1 action type selected, the action sequence gets randomized. The number of action types can\'t be less than number of actions.'
        }
    },
    'image_faceshot':{
        label:'Whether to return faceshot image, after successful liveness detection',
        notice:{
            dec:'For business privacy and security, after successful liveness detection, a faceshot image is added to the images field.'
        }
    },
    'multiple_faces_detection':{
        label:'Whether to detect multiple faces during liveness detection',
        notice:{
            dec:'If enabled, the liveness detection process will prompt you when multiple faces are detected, which may affect the pass rate.'
        }
    }
};

const typeMap = [
    {
        id:'flash',
        h1:'Flash',
        h2:'A non-cooperative liveness method with flickering screens',
        video:require('image/scene/flash.mp4')
    },
    {
        id:'active',
        h1:'Action',
        h2:'A liveness way of coordinating movements',
        video:require('image/scene/meglive.mp4')
    },
    {
        id:'active_flash',
        h1:'Dynamic',
        h2:'A liveness way of action + lighting',
        video:require('image/scene/meglive_flash.mp4')
    },
    {
        id:'distance_flash',
        h1:'Varifocal flash',
        h2:'A liveness way of lighting + varifocal',
        video:require('image/scene/distance_flash.mp4')
    }
];

class SDKLivenessForm extends React.Component {

    constructor(props){
        super(props);
        this.videoRef = {};
        this.id = props.id; //存在id为编辑模式
        this.mode = this.id === undefined ?'create':'edit';
        this.cacheValues = {};
        this.state = {
            type:defaultLivenessType,//用于处理类型与表单联动
            isShowMore:false,
            readOnly:false,
            loading:true,
            recordPerm:false
        };
        this.actionTextInitValue = {};
        ActionsMap.forEach(item=>{
            this.actionTextInitValue[item.key] = item.initValue;
        });
    }

    componentDidMount(){

        let editPromise = Promise.resolve();
        if(this.mode === 'edit'){
            editPromise = this.props.abortableAjax('GET','/living_scene/'+this.id).then(res=>{
                return res.data;
            });
        }
        editPromise.then((res)=>{
            //如果是编辑res不为空
            if(res){
                //先设置场景类型
                const data = res;
                const readOnly = data.state === 'default';
                this.setState({type:data.liveness_type,readOnly},()=>{
                    //设置播放视频
                    this.playVideo();
                    //获取现有表单数据
                    const {getFieldsValue,setFieldsValue} = this.props.form;
                    const values = getFieldsValue();
                    //需要提前配置的字段列表
                    const firstSetFields = ['get_liveness_video','speed_action_mode'];
                    const firstSetFieldsValue = {};
                    firstSetFields.forEach(item=>{
                        if(item in values){
                            firstSetFieldsValue[item] = data[item];
                        }
                    });
                    //先设置有影响字段
                    setFieldsValue(firstSetFieldsValue,()=>{
                        const values = getFieldsValue();
                        //取values存在的字段
                        const newValues = mixObj(values,data);
                        //特殊处理
                        if(values.interface_prompt_local){
                            const tipsValues = FormMap[data.interface_prompt_show];
                            const tips = {};
                            tipsValues.forEach(item=>{
                                tips[item.key] = data[item.key];
                            });
                            newValues.interface_prompt_local = {
                                action:data.interface_prompt_show,
                                tips,
                                liveness_keep_time:data.liveness_keep_time
                            };
                        }
                        //表单回填
                        setFieldsValue(newValues,()=>{
                            //设置不在表单字段
                            this.setState({
                                loading:false
                            });
                        });
                    });

                });
            }else{
                //创建自动播放默认
                this.playVideo();
                this.setState({
                    loading:false
                });
            }
        });
    }

    playVideo = ()=>{
        //播放视频逻辑，播放选中的，停止其他
        //先暂停所有
        Object.keys(this.videoRef).forEach(item=>{
            const videoDom = this.videoRef[item];
            if(!videoDom.paused){
                this.videoRef[item].pause();
            }
        });
        const selectVideoDom = this.videoRef[this.state.type];
        if(selectVideoDom.paused){
            selectVideoDom.play();
        }
    }

    onSave = ()=>{
        let url = '/living_scene';
        let type = 'put';
        if(this.id){
            url = '/living_scene/'+this.id;
            type = 'post';
        }
        this.props.form.validateFields((errors, values)=>{
            if(!errors){
                const {interface_prompt_local,...other} = values;
                this.setState({loading:true});
                const params = {
                    liveness_type:this.state.type,
                    ...other
                };
                let realParams = {...params};
                if(interface_prompt_local){
                    realParams = {
                        ...realParams,
                        //是否开启活体界面提示特殊处理
                        interface_prompt_show:interface_prompt_local.action,
                        ...interface_prompt_local.tips,
                        liveness_keep_time:interface_prompt_local.liveness_keep_time
                    };
                }

                this.props.abortableAjax(type,url,realParams).then(()=>{
                    message.success('Successful operation');
                    this.props.history.push('/pages/sdk-scenes');
                }).catch(()=>{
                    this.setState({loading:false});
                });
            }
        });
    }

    getLabel = (key,type)=>{
        return getLabel(LabelMap,key,type);
    }

    onShowMore = ()=>{
        this.setState({isShowMore:!this.state.isShowMore});
    }

    onLivenessTypeChange = (newType)=>{
        if(this.setDisabled('liveness_type')) return;
        //获取旧数据缓存
        let cacheValues = {}; //获取当前值
        const {getFieldsValue,setFieldsValue} = this.props.form;
        const value = this.state.type;
        if(value === 'flash'){
            cacheValues = getFieldsValue(['flash_light','flash_liveness_timeout']);
        }else if(value === 'active'){
            cacheValues = getFieldsValue(['liveness_action_count','liveness_timeout','maximum_brightness']);
        }else if(value === 'distance_flash'){
            cacheValues = getFieldsValue(['flash_liveness_timeout','distance_liveness_timeout']);
        }
        //当前值设置为缓存
        this.cacheValues[value] = cacheValues;
        this.setState({type:newType},()=>{
            //切换后回填缓存数据
            setFieldsValue(this.cacheValues[newType]);
            //重置interface_prompt_local字段
            setFieldsValue({interface_prompt_local:{action:0}});
            //设置播放
            this.playVideo();
        });
    }

    setDisabled(){
        return this.state.readOnly;
    }

    renderVideoMode(){
        const {getFieldValue,getFieldDecorator} = this.props.form;
        const get_liveness_video = getFieldValue('get_liveness_video');
        if(get_liveness_video === 1 || get_liveness_video === 2){
            return (
                <SubForm>
                    <FormItem colon={false} label={this.getLabel('storage_video_mode')} style={{
                        marginBottom:0
                    }}>
                        {getFieldDecorator('storage_video_mode',{
                            initialValue:0,
                            rules:[
                                {required:true,message:'not nullable'}
                            ]
                        })(
                            <Radio.Group disabled={this.setDisabled('storage_video_mode')}>
                                <Radio value={0}>Video of the Liveness stage</Radio>
                                <Radio value={1}>Video of all stages</Radio>
                                <Radio value={2}>Video of the entire SDK process</Radio>
                            </Radio.Group>
                        )}
                    </FormItem>
                </SubForm>
            );
        }
    }

    renderActiveTimeout = ()=>{
        const liveness_type = this.state.type;
        const {getFieldValue,getFieldDecorator} = this.props.form;
        if(liveness_type === 'active' && getFieldValue('speed_action_mode') === 1){
            return <SubForm>
                <FormItem colon={false} label={this.getLabel('active_liveness_timeout')} style={{
                    marginBottom:0
                }}>
                    {getFieldDecorator('active_liveness_timeout',{
                        initialValue:120,
                        rules:[
                            {required:true,message:'not nullable'}
                        ]
                    })(
                        <Radio.Group disabled={this.setDisabled('active_liveness_timeout')}>
                            <Radio value={60}>60s</Radio>
                            <Radio value={120}>120s</Radio>
                            <Radio value={180}>180s</Radio>
                        </Radio.Group>
                    )}
                </FormItem>
            </SubForm>;
        }
    }

    render(){
        const {getFieldDecorator,getFieldValue} = this.props.form;
        const formItemLayout = {
            labelCol: { span: 3 },
            wrapperCol: { span: 14 }
        };
        const liveness_type = this.state.type;
        const livenessTip = typeMap.find(item=>{
            return item.id === liveness_type;
        }).tip;
        return (
            <div style={{marginTop:20,marginBottom:20}}>
                <LoadingCover spinning={this.state.loading}>
                    <Form layout="vertical">
                        <FormItem label="Scenes Name" {...formItemLayout}>
                            {getFieldDecorator('name',{
                                rules:[
                                    {required:true,message:'not nullable'},
                                    {max:20,message:'Cannot be greater than 20 characters'}
                                ]
                            })(
                                <Input placeholder="Cannot be greater than 20 characters" disabled={this.setDisabled('name')}/>
                            )}
                        </FormItem>
                        <FormItem label="Scenes Describe" {...formItemLayout}>
                            {getFieldDecorator('description',{
                                rules:[
                                    {max:50,message:'Cannot be greater than 50 characters'}
                                ]
                            })(
                                <Input placeholder="Cannot be greater than 50 characters" disabled={this.setDisabled('description')}/>
                            )}
                        </FormItem>
                        <div className={style.line}></div>
                        <h1 className={style.title}>config</h1>
                        <FormItem
                            colon={false}
                            style={{marginBottom:0}}
                            label={(
                                <div className={style.livenessTypeItem}>
                                    Choose liveness mode
                                    {livenessTip && <span><Icon className={style.livenessTypeItemIcon} type="info-circle" theme="filled" />{livenessTip}</span>}
                                </div>
                            )}
                            required={true}
                        >
                            <div>
                                {typeMap.map((item,index)=>{
                                    const boxClass = classnames({
                                        [style.livenessType]:true,
                                        [style.typeActive]:liveness_type === item.id,
                                        [style.disabled]:this.setDisabled('liveness_type')
                                    });
                                    return (
                                        <div
                                            className={boxClass}
                                            onClick={this.onLivenessTypeChange.bind(this,item.id)}
                                            key={index}
                                        >
                                            <h1>{item.h1}</h1>
                                            <h2>{item.h2}</h2>
                                            <div className={style.videoBox}>

                                                <video muted loop src={item.video} ref={(ref)=>this.videoRef[item.id] = ref}></video>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </FormItem>
                        {liveness_type === 'active_flash' && <FormItem colon={false} label={this.getLabel('active_flash_action_count')}>
                            {getFieldDecorator('active_flash_action_count',{
                                initialValue:1
                            })(
                                <Radio.Group
                                    disabled={this.setDisabled('active_flash_action_count')}
                                >
                                    <Radio value={1}>1 Action</Radio>
                                    <Radio value={2}>2 Actions</Radio>
                                    <Radio value={3}>3 Actions</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>}

                        {liveness_type === 'active_flash' && <SubForm><FormItem colon={false} label={this.getLabel('liveness_active_type_queue')}>
                            {getFieldDecorator('liveness_active_type_queue',{
                                initialValue:[1,2,3,4],
                                rules:[
                                    {required:true,message:'not nullable'},
                                    {validator:(rules,value,callback)=>{
                                        const active_flash_action_count = getFieldValue('active_flash_action_count');
                                        if(value.length < active_flash_action_count){
                                            callback('Please select at least ' + active_flash_action_count + ' action(s)');
                                        }else{
                                            callback();
                                        }
                                    }}

                                ]
                            })(
                                <Checkbox.Group options={Actions} />
                            )}
                        </FormItem></SubForm>}
                        {liveness_type === 'active_flash' && <FormItem colon={false} label={this.getLabel('liveness_active_type')}>
                            {getFieldDecorator('liveness_active_type',{
                                initialValue:1,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group
                                    disabled={this.setDisabled('liveness_active_type')}

                                >
                                    {Actions.map(item=>{
                                        return <Radio key={item.value} value={item.value} text={item.label}>{item.label}</Radio>;
                                    })}
                                </Radio.Group>
                            )}
                        </FormItem>}
                        {liveness_type === 'active_flash' && <FormItem colon={false} label={this.getLabel('liveness_multi_active_guide_text')}>
                            {getFieldDecorator('liveness_multi_active_guide_text',{
                                initialValue:this.actionTextInitValue,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <ItemAction disabled={this.setDisabled('liveness_multi_active_guide_text')}
                                    actionMap={ActionsMap}/>
                            )}
                        </FormItem>}
                        {(liveness_type === 'distance_flash') && <FormItem colon={false} label={this.getLabel('distance_liveness_timeout',liveness_type)} >
                            <div className={style.risk}><img src={require('image/scene/risk.png')} alt="" /></div>
                            {getFieldDecorator('distance_liveness_timeout',{
                                initialValue:60,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('distance_liveness_timeout')}>
                                    <Radio value={60}>60s</Radio>
                                    <Radio value={120}>120s</Radio>
                                    <Radio value={180}>180s</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>}
                        {(liveness_type === 'flash' || liveness_type === 'active_flash' || liveness_type === 'distance_flash') && <FormItem colon={false} label={this.getLabel('flash_light',liveness_type)} >
                            <div className={style.risk}><img src={require('image/scene/risk.png')} alt="" /></div>
                            {getFieldDecorator('flash_light',{
                                initialValue:1,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('flash_light')}>
                                    <Radio value={1}>turn on(recommend)</Radio>
                                    <Radio value={0}>turn off</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>}
                        {liveness_type === 'active' && <FormItem colon={false} label={this.getLabel('liveness_action_count')} >
                            <div className={style.risk}><img src={require('image/scene/risk.png')} alt="" /></div>
                            {getFieldDecorator('liveness_action_count',{
                                initialValue:3,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('liveness_action_count')}>
                                    <Radio value={3}>3 moves randomly</Radio>
                                    <Radio value={2}>2 moves randomly</Radio>
                                    <Radio value={1}>1 moves randomly</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>}
                        {(liveness_type === 'active' || liveness_type === 'active_flash') && <FormItem colon={false} label={this.getLabel('liveness_timeout',liveness_type)} >
                            <div className={style.risk}><img src={require('image/scene/risk.png')} alt="" /></div>
                            {getFieldDecorator('liveness_timeout',{
                                initialValue:10,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('liveness_timeout')}>
                                    <Radio value={10}>10s</Radio>
                                    <Radio value={20}>20s</Radio>
                                    <Radio value={60}>60s</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>}
                        {(liveness_type === 'active') && <FormItem colon={false} label={this.getLabel('speed_action_mode',liveness_type)} >
                            <div className={style.risk}><img src={require('image/scene/risk.png')} alt="" /></div>
                            {getFieldDecorator('speed_action_mode',{
                                initialValue:0,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('speed_action_mode')}>
                                    <Radio value={1}>turn on</Radio>
                                    <Radio value={0}>turn off</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>}
                        {this.renderActiveTimeout()}
                        {(liveness_type === 'flash' || liveness_type === 'active_flash' || liveness_type === 'distance_flash') && <FormItem colon={false} label={this.getLabel('flash_liveness_timeout',liveness_type)} >
                            <div className={style.risk}><img src={require('image/scene/risk.png')} alt="" /></div>
                            {getFieldDecorator('flash_liveness_timeout',{
                                initialValue:120,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('flash_liveness_timeout')}>
                                    <Radio value={60}>60s</Radio>
                                    <Radio value={120}>120s</Radio>
                                    <Radio value={180}>180s</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>}
                        {liveness_type === 'active' && <FormItem colon={false} label={this.getLabel('maximum_brightness')} >
                            <div className={style.risk}><img src={require('image/scene/risk.png')} alt="" /></div>
                            {getFieldDecorator('maximum_brightness',{
                                initialValue:1,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('maximum_brightness')}>
                                    <Radio value={1}>turn on(recommend)</Radio>
                                    <Radio value={0}>turn off</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>}
                        <FormItem colon={false} label={this.getLabel('device_risk')} >
                            <div className={style.risk}><img src={require('image/scene/risk.png')} alt="" /></div>
                            {getFieldDecorator('device_risk',{
                                initialValue:1,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('device_risk')}>
                                    <Radio value={2}>Enable device risk detection (only return risk warnings)</Radio>
                                    <Radio value={1}>Enable device risk detection and intercept high risks</Radio>
                                    <Radio value={0}>turn off</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>
                        <FormItem colon={false} label={this.getLabel('get_liveness_video')} >
                            {getFieldDecorator('get_liveness_video',{
                                initialValue:0,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('get_liveness_video')}>
                                    <Radio value={0}>do not save</Radio>
                                    <Radio value={1}>save videos and pictures</Radio>
                                    <Radio value={2}>save video only</Radio>
                                    <Radio value={3}>save pictures only</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>
                        <FormItem colon={false} label={this.getLabel('multiple_faces_detection')} >
                            {getFieldDecorator('multiple_faces_detection',{
                                initialValue:0,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('multiple_faces_detection')}>
                                    <Radio value={1}>turn on</Radio>
                                    <Radio value={0}>turn off</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>
                        {this.renderVideoMode()}
                        <FormItem colon={false} label={this.getLabel('interface_prompt_local')} >
                            {getFieldDecorator('interface_prompt_local',{
                                initialValue:{
                                    action: 0
                                }
                            })(
                                <ItemLiveInterfaceTips
                                    disabled={this.setDisabled('interface_prompt_local')}
                                    hasMakeSure={liveness_type === 'active_flash'}
                                />
                            )}
                        </FormItem>
                        <FormItem colon={false} label={this.getLabel('face_risk')} >
                            {getFieldDecorator('face_risk',{
                                initialValue:0,
                                rules:[
                                    {required:true,message:'not nullable'}
                                ]
                            })(
                                <Radio.Group disabled={this.setDisabled('maximum_brightness')}>
                                    <Radio value={1}>turn on</Radio>
                                    <Radio value={0}>turn off</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>
                        <FormItem colon={false} label={this.getLabel('image_faceshot')} >
                            {getFieldDecorator('image_faceshot',{
                                initialValue:0
                            })(
                                <Radio.Group disabled={this.setDisabled('image_faceshot')}>
                                    <Radio value={1}>turn on</Radio>
                                    <Radio value={0}>turn off</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>
                    </Form>
                    <div style={{marginTop:'64px'}}>
                        {!this.state.readOnly && <Button type="primary" style={{marginRight:24}} onClick={this.onSave}>Save</Button>}
                        <Link to="/pages/sdk-scenes"><Button>Back</Button></Link>
                    </div>

                </LoadingCover>
            </div>
        );

    }
}

export default Form.create({

    onFieldsChange(props, changedFields){
        if(!changedFields) return;
        if ('active_flash_action_count' in changedFields) {
            // "antd": "3.8.4" props中不存在form。只能通知到父级
            props.validateFields && props.validateFields(['liveness_active_type_queue'],{ force: true });
        }
    }
})(abortAjaxHoc(withRouter(SDKLivenessForm)));



// WEBPACK FOOTER //
// ./src/pages/SDKLiveness/SDKLivenessForm.js